import { FORM_ERROR } from "final-form";
import { useIntl } from "react-intl";
import useTrashablePromises from "hooks/useTrashablePromises";
import translateError from "utils/translateError";
import useGlobalContext from "hooks/globalData";
import {
  SaveResponse,
  IResourceLibraryItem,
  SaveResourceLibraryItemProfessionRequest,
} from "services/KnowfullyAdminClient";

import ResourceLibraryItemProfessionForm from "./ResourceLibraryItemProfessionForm";

type ResourceLibraryItemProfessionCreateFormProps = {
  resourceLibraryItem: IResourceLibraryItem;
  onResourceLibraryItemProfessionCreated: (
    createdResourceLibraryItemProfession: SaveResponse
  ) => void;
  onCancel: () => void;
};

const ResourceLibraryItemProfessionCreateForm = ({
  onResourceLibraryItemProfessionCreated,
  onCancel,
  resourceLibraryItem,
}: ResourceLibraryItemProfessionCreateFormProps) => {
  const { registerPromise } = useTrashablePromises();
  const { formatMessage: t } = useIntl();
  const { resourceLibraryService } = useGlobalContext();

  const onSubmit = (values: SaveResourceLibraryItemProfessionRequest) => {
    return registerPromise(
      resourceLibraryService.saveResourceLibraryItemProfession(
        resourceLibraryItem.id,
        values
      )
    )
      .then((createdResourceLibraryItemProfession) => {
        onResourceLibraryItemProfessionCreated(
          createdResourceLibraryItemProfession
        );
      })
      .catch((err: any) => {
        return { [FORM_ERROR]: translateError(err, t) };
      });
  };

  return (
    <ResourceLibraryItemProfessionForm
      onSubmit={onSubmit}
      submitLabel={t({ id: "resourceLibraryFormCreateItemProfessionButton" })}
      onCancel={onCancel}
    />
  );
};

export default ResourceLibraryItemProfessionCreateForm;
